import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoal = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 12 11.25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "vector",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.5625 0C0.25184 0 0 0.25184 0 0.5625C0 0.87316 0.25184 1.125 0.5625 1.125H6.375C8.86028 1.125 10.875 3.13972 10.875 5.625C10.875 8.11028 8.86028 10.125 6.375 10.125H0.5625C0.25184 10.125 0 10.3768 0 10.6875C0 10.9982 0.25184 11.25 0.5625 11.25H6.375C9.4816 11.25 12 8.7316 12 5.625C12 2.5184 9.4816 0 6.375 0H0.5625Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.83086 6.48664C9.35499 8.39526 7.42198 9.55674 5.51336 9.08086C3.60474 8.60499 2.44326 6.67198 2.91914 4.76336C3.39501 2.85474 5.32802 1.69326 7.23664 2.16914C9.14526 2.64501 10.3067 4.57802 9.83086 6.48664ZM8.25465 5.02997C8.24152 5.08263 8.19233 5.11814 8.13822 5.11403L6.5479 4.9932C6.50434 4.98989 6.46674 4.96141 6.45177 4.92037L5.9949 3.6681C5.9766 3.61794 5.9965 3.56186 6.04232 3.53444L7.26438 2.80328C7.30276 2.78031 7.35116 2.78255 7.38726 2.80897L8.52875 3.64438C8.56525 3.67109 8.58195 3.71724 8.57101 3.76112L8.25465 5.02997ZM4.70933 3.62144C4.72283 3.59409 4.72451 3.5624 4.71399 3.53378L4.58288 3.17712C4.5555 3.10263 4.46118 3.07991 4.40289 3.13377L3.75149 3.73557C3.6418 3.8369 3.55936 3.96419 3.51176 4.10572L3.23982 4.91421C3.21394 4.99115 3.27646 5.06901 3.35717 5.06036L3.97406 4.99423C4.01195 4.99017 4.04513 4.967 4.062 4.93283L4.70933 3.62144ZM4.2154 6.10561C4.15307 6.10252 4.10038 6.15127 4.09863 6.21365L4.06875 7.2791C4.06771 7.31619 4.08522 7.35136 4.11545 7.37289L5.25856 8.18678C5.29474 8.21255 5.34279 8.21433 5.38078 8.19131L6.40268 7.57224C6.45657 7.53959 6.47264 7.46874 6.4381 7.41604L5.65612 6.2228C5.63662 6.19304 5.60407 6.1744 5.56854 6.17264L4.2154 6.10561ZM8.07257 8.33088C8.01973 8.37796 7.93695 8.36443 7.90186 8.30298L7.53742 7.66481C7.51464 7.62493 7.5187 7.57515 7.54764 7.53949L8.52919 6.3298C8.54614 6.30892 8.57007 6.29487 8.59658 6.29027L9.27592 6.17231C9.35857 6.15795 9.42679 6.23672 9.40078 6.31648L9.09341 7.25888C9.04458 7.40861 8.9569 7.54272 8.83932 7.64751L8.07257 8.33088Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.25 3.9375C2.25 4.24816 1.99816 4.5 1.6875 4.5H0.5625C0.25184 4.5 0 4.24816 0 3.9375C0 3.62684 0.25184 3.375 0.5625 3.375H1.6875C1.99816 3.375 2.25 3.62684 2.25 3.9375Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.6875 7.875C1.99816 7.875 2.25 7.62316 2.25 7.3125C2.25 7.00184 1.99816 6.75 1.6875 6.75H0.5625C0.25184 6.75 0 7.00184 0 7.3125C0 7.62316 0.25184 7.875 0.5625 7.875H1.6875Z",
				fill: "currentColor"
			})
		]
	})
});
export default SvgGoal;
